// @module C3.PDPSerialLotFunctionality.LotItemImageGallery
define('C3.PDPSerialLotFunctionality.LotItemImageGallery.View'
,   [
        'lotitem_imagegallery.tpl'
    ,   'Backbone'
    ,   'jQuery'
    ,   'underscore'
    ,   'Utils'
    ,   'Utilities.ResizeImage'
    ,   'zoom'
    ]
,   function (
        lotitem_imagegallery_tpl
    ,   Backbone
    ,   jQuery
    ,   _
    ,   Utils
    ,   resizeImage
    )
{
    'use strict';

    return Backbone.View.extend({

        template: lotitem_imagegallery_tpl

    ,   events: {
            'contextmenu .lot-item-image-gallery': 'preventDownload'
        ,   'dragstart .lot-item-image-gallery img': 'preventDownload'
        }

    ,   initialize: function(options) {
            this.options = options;
            this.images = options.images || [];
            this.application = options.application;
            this.isLoading = options.isLoading || false;
            this.isZoomEnabled = SC.CONFIGURATION.isZoomEnabled;
            this.$slider = null;
        }

    ,   preventDownload: function(e) {
            e.preventDefault();
            return false;
        }

    ,   initSliderZoom: function(forceInit) {
            if (this.isZoomEnabled) {
                this.initZoom();
            }
            this.initSlider(forceInit);
        }

    ,   initZoom: function() {
            var self = this;
            // Only enable zoom on desktop (non-touch devices)
            if (!SC.ENVIRONMENT.isTouchEnabled) {
                var images = this.images;
                this.$('[data-zoom]:not(.bx-clone)').each(function(slide_index) {
                    var img = images[slide_index];
                    if (img && img.url) {
                        self.$(this).zoom(resizeImage(img.url, 'zoom'), slide_index);
                    }
                });
            }
        }

    ,   initSlider: function() {
            var self = this;
            
            if (this.images.length > 1) {
                this.$slider = Utils.initBxSlider(this.$('[data-slider]'), {
                    buildPager: function(slideIndex) {
                        var image = self.images[slideIndex];
                        if (image) {
                            return '<img src="' + image.url + '" alt="' + (image.altimagetext || '') + '">';
                        }
                        return '';
                    },
                    startSlide: 0,
                    adaptiveHeight: true,
                    touchEnabled: true,
                    pager: true,
                    controls: true,
                    infiniteLoop: true,
                    onSliderLoad: function() {
                        self.$('[data-slider]').addClass('bx-loaded');
                        // Replace pager images with thumbnail divs (better styling control)
                        self.replacePagerImages();
                        // Add pager arrow navigation
                        self.initPagerArrows();
                    },
                    onSlideAfter: function() {
                        // Sync pager height on slide change
                        var $viewport = self.$('.bx-viewport');
                        var $wrapper = self.$('.custom-pager-wrapper');
                        if ($viewport.length && $wrapper.length) {
                            $wrapper.height($viewport.height());
                        }
                    }
                });
            }
        }

    ,   initPagerArrows: function() {
            var self = this;
            var $pager = this.$('.bx-pager');
            var $viewport = this.$('.bx-viewport');

            if ($pager.length && $viewport.length) {
                // Wrap pager in custom wrapper if not already
                if (!$pager.parent().hasClass('custom-pager-wrapper')) {
                    $pager.wrap('<div class="custom-pager-wrapper"></div>');
                }
                var $wrapper = $pager.parent();

                // Add up/down buttons if not present
                if (!$wrapper.find('.pager-up').length) {
                    $wrapper.prepend('<button type="button" class="pager-up">▲</button>');
                    $wrapper.append('<button type="button" class="pager-down">▼</button>');
                }

                var $up = $wrapper.find('.pager-up');
                var $down = $wrapper.find('.pager-down');
                var scrollAmount = 100; // px per click

                $up.on('click', function() {
                    $pager.animate({ scrollTop: $pager.scrollTop() - scrollAmount }, 250);
                });

                $down.on('click', function() {
                    $pager.animate({ scrollTop: $pager.scrollTop() + scrollAmount }, 250);
                });

                function syncPagerHeight() {
                    // Only apply height sync on desktop (>= 768px)
                    if (jQuery(window).width() >= 768) {
                        var viewportHeight = $viewport.height();
                        var arrowHeight = $up.outerHeight(true) + $down.outerHeight(true);
                        var scrollAreaHeight = viewportHeight - arrowHeight;

                        $wrapper.height(viewportHeight);
                        $pager.height(scrollAreaHeight);
                    } else {
                        // Clear inline heights on mobile
                        $wrapper.css('height', '');
                        $pager.css('height', '');
                    }
                }

                syncPagerHeight();
                jQuery(window).on('resize', _.debounce(syncPagerHeight, 150));

                // Add mobile horizontal arrows
                this.initMobilePagerArrows($pager, $wrapper);
            }
        }

    ,   initMobilePagerArrows: function($pager, $wrapper) {
            // Only on mobile
            if (jQuery(window).width() >= 768) {
                return;
            }

            // Add left/right buttons for horizontal scroll
            if (!$wrapper.find('.pager-left').length) {
                $wrapper.prepend('<button type="button" class="pager-left">◀</button>');
                $wrapper.append('<button type="button" class="pager-right">▶</button>');
            }

            var $left = $wrapper.find('.pager-left');
            var $right = $wrapper.find('.pager-right');
            var scrollAmount = 80; // px per click

            $left.on('click', function() {
                $pager.animate({ scrollLeft: $pager.scrollLeft() - scrollAmount }, 250);
            });

            $right.on('click', function() {
                $pager.animate({ scrollLeft: $pager.scrollLeft() + scrollAmount }, 250);
            });
        }
    
    ,   replacePagerImages: function() {
            // Only on desktop
            if (Utils.isPhoneDevice()) {
                return;
            }
            
            var $pager = this.$el.find('.bx-pager');
            var $pagerImages = $pager.find('img');
            
            $pagerImages.each(function(i, img) {
                var $img = jQuery(img);
                var src = $img.attr('src');
                var $parent = $img.parent();
                
                // Create thumbnail div with background-image
                var $thumbnailDiv = jQuery('<div class="thumbnail-img"></div>');
                $thumbnailDiv.attr('id', i + 'lotpdpthumbnailimg');
                $thumbnailDiv.css({
                    'background-image': "url('" + src + "')",
                    'background-size': 'cover',
                    'background-repeat': 'no-repeat',
                    'background-position': 'center',
                    'width': '70px',
                    'height': '70px'
                });
                
                // Replace img with div
                $parent.append($thumbnailDiv);
                $img.remove();
            });
        }
    
    ,   destroy: function() {
            // Destroy bxSlider to prevent memory leaks
            if (this.$slider) {
                try {
                    this.$slider.destroySlider();
                } catch(e) {}
                this.$slider = null;
            }
            
            // Remove event listeners and clean up
            this.undelegateEvents();
            this.$el.removeData().unbind();
            this.remove();
        }

    ,   getContext: function() {
            var images = this.images || [];
            var showImages = images.length > 0;
            var showImageSlider = images.length > 1;
            var firstImage = images[0] || {};

            return {
                isLoading: this.isLoading,
                showImages: showImages,
                showImageSlider: showImageSlider,
                images: images,
                imagesUpdated: images,
                firstImage: firstImage,
                firstImageUpdated: firstImage,
                imageCount: images.length,
                isPhoneDevice: Utils.isPhoneDevice(),
                imageResizeId: Utils.getViewportWidth() < 768 ? 'thumbnail' : 'main'
            };
        }
    });
});
